import { Link } from 'react-router-dom'
import { SEO } from '@/components/seo'

const resourceCategories = [
  {
    icon: 'M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    title: 'Value of Advice Calculator',
    description:
      'Generate professional reports demonstrating the value of financial advice, backed by Vanguard and ILC research.',
    link: '/value-of-advice',
    cta: 'Open calculator',
    highlight: true,
  },
  {
    icon: 'M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25',
    title: 'Documentation',
    description:
      'Value of Advice printouts, guides, and resources to help you demonstrate value to clients.',
    link: '/value-of-advice',
    cta: 'Browse docs',
  },
  {
    icon: 'M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z',
    title: 'Help & Support',
    description:
      'Need assistance? Our friendly support team typically responds within a few hours during business days.',
    link: 'mailto:support@wealthspace.ai',
    cta: 'Email support',
    external: true,
  },
  {
    icon: 'M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605',
    title: 'WealthSpace Keynote',
    description:
      'Join us for our upcoming keynote event showcasing the future of WealthSpace and the latest innovations in adviser technology.',
    link: 'https://keynote.wealthspace.co.uk',
    cta: 'Learn more',
    external: true,
  },
]

const blogPosts = [
  {
    category: 'Event',
    title: 'Announcing the WealthSpace Keynote 2026',
    excerpt:
      'Join us for our first-ever keynote event. A live showcase of what is next for WealthSpace, featuring product reveals, adviser stories, and a vision for the future.',
    date: '4 Jan 2026',
    readTime: '4 min read',
    link: '/blog/wealthspace-keynote-2026',
    gradient: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%)',
    iconPath:
      'M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z',
  },
  {
    category: 'Product Update',
    title: 'WealthSpace V2 is Here: 40+ Features to Transform Your Practice',
    excerpt:
      'Our biggest release yet brings a completely reimagined platform with faster workflows, smarter AI, and powerful new integrations built from adviser feedback.',
    date: '6 Jan 2026',
    readTime: '5 min read',
    link: '/blog/wealthspace-v2-launch',
    gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 50%, #0f766e 100%)',
    iconPath:
      'M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z',
  },
  {
    category: 'Company News',
    title: 'WealthSpace Featured in Money Marketing',
    excerpt:
      'We are proud to share our story with the wider adviser community. Read how WealthSpace is helping firms reclaim their time and serve more clients.',
    date: '18 Nov 2025',
    readTime: '4 min read',
    link: '/blog/money-marketing-feature',
    gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
    iconPath:
      'M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z',
  },
  {
    category: 'Industry Recognition',
    title: 'Lang Cat Tech Catwalk and TechSpark Fintech Finalists',
    excerpt:
      'WealthSpace has been recognised as a finalist at both the Lang Cat Tech Catwalk and TechSpark Fintech of the Year awards. A proud moment for the team.',
    date: '22 May 2025',
    readTime: '3 min read',
    link: '/blog/industry-awards-2025',
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #f97316 50%, #ef4444 100%)',
    iconPath:
      'M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0',
  },
  {
    category: 'Product Launch',
    title: 'Introducing Ramble to Action: AI Meeting Capture',
    excerpt:
      'We are launching our AI-powered meeting capture feature that turns conversations into structured notes, action items, and CRM updates automatically.',
    date: '15 Sep 2024',
    readTime: '4 min read',
    link: '/blog/introducing-ramble-to-action',
    gradient: 'linear-gradient(135deg, #059669 0%, #047857 50%, #065f46 100%)',
    iconPath:
      'M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z',
  },
  {
    category: 'Our Story',
    title: 'Why We Built WealthSpace',
    excerpt:
      'The story behind WealthSpace. Built by advisers who understood the daily frustrations of running a practice and decided to do something about it.',
    date: '3 Mar 2024',
    readTime: '5 min read',
    link: '/blog/why-we-built-wealthspace',
    gradient: 'linear-gradient(135deg, #1e3a5f 0%, #1e40af 50%, #3730a3 100%)',
    iconPath:
      'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z',
  },
]

const upcomingWebinars = [
  {
    title: 'Webinars Coming Soon',
    date: 'Stay Tuned',
    time: '',
    description:
      'We are planning new webinar sessions. Check back soon or contact us to be notified when dates are announced.',
  },
]

function ResourceIcon({ path }: { path: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-8 h-8"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d={path} />
    </svg>
  )
}

function ResourceCard({
  resource,
}: {
  resource: (typeof resourceCategories)[0]
}) {
  const cardClasses = `block p-8 rounded-2xl border transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)] ${
    resource.highlight
      ? 'border-accent-teal/30 bg-gradient-to-br from-accent-teal/[0.08] to-accent-teal/[0.02] hover:border-accent-teal/40'
      : 'border-white/[0.06] bg-gradient-to-br from-white/[0.03] to-white/[0.01] hover:border-accent-teal/20'
  }`

  const content = (
    <>
      <div
        className={`w-14 h-14 rounded-xl flex items-center justify-center text-accent-teal mb-5 ${
          resource.highlight ? 'bg-accent-teal/20' : 'bg-accent-teal/10'
        }`}
      >
        <ResourceIcon path={resource.icon} />
      </div>
      <h3 className="text-xl font-semibold text-brand-light mb-3">{resource.title}</h3>
      <p className="text-[15px] text-brand-muted leading-relaxed mb-5">
        {resource.description}
      </p>
      <span className="text-sm font-semibold text-accent-teal flex items-center gap-1.5">
        {resource.cta}
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="w-4 h-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
          />
        </svg>
      </span>
    </>
  )

  if (resource.external) {
    return (
      <a href={resource.link} className={cardClasses} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    )
  }

  return (
    <Link to={resource.link} className={cardClasses}>
      {content}
    </Link>
  )
}

function BlogCard({ post }: { post: (typeof blogPosts)[0] }) {
  return (
    <Link
      to={post.link}
      className="block rounded-2xl border border-white/[0.06] bg-gradient-to-br from-white/[0.03] to-white/[0.01] overflow-hidden transition-all duration-400 hover:-translate-y-1 hover:border-accent-teal/20 hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)]"
    >
      <div
        className="h-40 flex items-center justify-center relative overflow-hidden"
        style={{ background: post.gradient }}
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(255,255,255,0.15)_0%,transparent_50%)]" />
        <div className="absolute -bottom-5 -right-5 w-[100px] h-[100px] bg-white/10 rounded-full" />
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="w-12 h-12 opacity-90 relative z-10 text-white"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d={post.iconPath} />
        </svg>
      </div>
      <div className="p-6">
        <div className="text-xs font-semibold text-accent-teal uppercase tracking-wider mb-2">
          {post.category}
        </div>
        <h3 className="text-lg font-semibold text-brand-light mb-3 leading-snug">
          {post.title}
        </h3>
        <p className="text-sm text-brand-muted leading-relaxed mb-4">{post.excerpt}</p>
        <div className="text-[13px] text-brand-subtle">
          {post.date} · {post.readTime}
        </div>
      </div>
    </Link>
  )
}

export default function ResourcesPage() {
  return (
    <>
      <SEO
        title="Adviser Resources, Guides & Templates | WealthSpace"
        description="Free resources for financial advisers: documentation, help guides, webinars, templates and blog posts to maximise your WealthSpace experience."
        url="/resources"
      />

      {/* Hero */}
      <section className="pt-[100px] pb-20 px-6 text-center relative overflow-hidden">
        <div className="absolute -top-[100px] -right-[100px] w-[400px] h-[400px] bg-[radial-gradient(circle,rgba(20,184,166,0.15)_0%,transparent_70%)] rounded-full" />
        <div className="max-w-[800px] mx-auto relative z-10">
          <h1 className="font-serif text-[clamp(36px,5vw,52px)] font-normal text-brand-light mb-6 leading-tight">
            Learn, grow, <span className="text-accent-teal italic">succeed</span>
          </h1>
          <p className="text-xl text-brand-muted leading-relaxed">
            Everything you need to get the most out of WealthSpace - from documentation to
            live webinars.
          </p>
        </div>
      </section>

      {/* Resource Categories */}
      <section className="px-6 pb-20 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {resourceCategories.map((resource, index) => (
            <ResourceCard key={index} resource={resource} />
          ))}
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 px-6 bg-black/20">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-serif text-4xl font-normal text-brand-light mb-12 text-center">
            Latest from the <span className="text-accent-teal italic">blog</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.map((post, index) => (
              <BlogCard key={index} post={post} />
            ))}
          </div>
        </div>
      </section>

      {/* Upcoming Webinars */}
      <section className="py-20 px-6 max-w-[1200px] mx-auto">
        <h2 className="font-serif text-4xl font-normal text-brand-light mb-12 text-center">
          Upcoming <span className="text-accent-teal italic">webinars</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {upcomingWebinars.map((webinar, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl border border-white/[0.06] bg-gradient-to-br from-white/[0.03] to-white/[0.01]"
            >
              <div className="text-sm font-semibold text-accent-teal mb-2">{webinar.date}</div>
              <h3 className="text-lg font-semibold text-brand-light mb-2">{webinar.title}</h3>
              {webinar.time && (
                <div className="text-sm text-brand-muted mb-3">{webinar.time}</div>
              )}
              <p className="text-sm text-brand-subtle leading-relaxed">{webinar.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 text-center bg-gradient-to-b from-transparent via-accent-teal/5 to-transparent">
        <h2 className="font-serif text-[clamp(32px,4vw,40px)] font-normal text-brand-light mb-4">
          Still have <span className="text-accent-teal italic">questions?</span>
        </h2>
        <p className="text-lg text-brand-muted mb-8">
          Our support team is here to help you get started.
        </p>
        <a
          href="mailto:support@wealthspace.ai"
          className="inline-flex items-center gap-2 px-9 py-[18px] bg-gradient-to-r from-accent-teal to-accent-emerald text-dark-bg font-semibold rounded-md hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(20,184,166,0.35)] transition-all"
        >
          Contact support
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="w-[18px] h-[18px]"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </a>
      </section>
    </>
  )
}
